var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'base-social-icon',
    {disabled: _vm.disabled},
    {active: _vm.active} ],on:{"click":_vm.onClick,"mouseenter":function($event){_vm.mouseOver = true},"mouseleave":function($event){_vm.mouseOver = false}}},[(_vm.href)?[_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon}})])]:[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }